import * as React from 'react';
import { InputTextarea } from 'primereact/inputtextarea';
import { AdminMedicineModel } from "../../models/medicine";
import Translate from '../../common/functions/translate';

interface IProps {
  handleChange: any,
  medicine: AdminMedicineModel,
  selectedLangId: number,
  getSafetyDataValueContent: any
}

interface IState {
}

class MedicineTabSafetyData extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
    };
  }

  public render() {

    const { safetyData } = this.props.medicine;

    return (
      <div className="p-grid p-fluid p-md-12">
        <div className="p-col-12 p-md-12">
          <label>{Translate("StoragePlace and storagePrecautions")}:</label>
          <InputTextarea
            name="storagePrecautions"
            style={{ width: '100%' }}
            onChange={(e) => this.props.handleChange('storagePrecautions', e.target['value'])}
            value={this.props.getSafetyDataValueContent('storagePrecautions')}
          />
        </div>
        <div className="p-col-12 p-md-12">
          <label>{Translate("ShelfLife")}:</label>
          <InputTextarea
            name="shelfLife"
            style={{ width: '100%' }}
            onChange={(e) => this.props.handleChange('shelfLife', e.target['value'])}
            value={this.props.getSafetyDataValueContent('shelfLife')}
          />
        </div>
        <div className="p-col-12 p-md-12">
          <label>{Translate("ProductHandlingAndDisposal")}:</label>
          <InputTextarea
            name="productDisposal"
            style={{ width: '100%' }}
            onChange={(e) => this.props.handleChange('productDisposal', e.target['value'])}
            value={this.props.getSafetyDataValueContent('productDisposal')}
          />
        </div>
      </div>
    )
  }
}

export default MedicineTabSafetyData;